module.exports = __webpack_public_path__ + "img/DSC_2850.79aad251.png";